"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@mui/material/utils");
var Icon = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor", viewBox: "0 0 25 24" }, props),
    React.createElement("path", { fillRule: "evenodd", d: "M12.64 20.14a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm6.4-8a6.4 6.4 0 1 1-12.8 0 6.4 6.4 0 0 1 12.8 0ZM7.104 11.25s.984.739 1.715.75c.758.012 1.79-.75 1.79-.75s1.185.777 2.03.75c.777-.025 1.845-.75 1.845-.75s1.033.735 1.792.75c.797.016 1.897-.75 1.897-.75s.29 1.351-.259 2.859c-.637 1.75-2.302 3.695-5.275 3.695-3.003 0-4.657-1.93-5.285-3.695-.53-1.488-.25-2.859-.25-2.859Z", clipRule: "evenodd" }))); };
var SvgSewage = (0, utils_1.createSvgIcon)(React.createElement(Icon, null), 'SvgSewage');
exports.default = SvgSewage;
